var exports = {
  "IW": "VoiceParticipantAvatarList.module__stackAvatar___QXJnc0",
  "K_": "VoiceParticipantAvatarList.module__stackAvatarSpeaking___QXJnc0",
  "Eh": "VoiceParticipantAvatarList.module__wrapContainer___QXJnc0",
  "EN": "VoiceParticipantAvatarList.module__wrapAvatarSlot___QXJnc0",
  "FU": "VoiceParticipantAvatarList.module__wrapAvatarSlotAnimated___QXJnc0",
  "ee": "VoiceParticipantAvatarList.module__wrapAvatar___QXJnc0",
  "lE": "VoiceParticipantAvatarList.module__wrapAvatarAnimated___QXJnc0",
  "i1": "VoiceParticipantAvatarList.module__remainingCount___QXJnc0",
  "jC": "VoiceParticipantAvatarList.module__popoutContainer___QXJnc0",
  "qE": "VoiceParticipantAvatarList.module__popoutList___QXJnc0",
  "Az": "VoiceParticipantAvatarList.module__popoutRow___QXJnc0",
  "ps": "VoiceParticipantAvatarList.module__popoutRowAvatar___QXJnc0",
  "fU": "VoiceParticipantAvatarList.module__popoutRowName___QXJnc0",
};

module.exports = exports;
